import { render, staticRenderFns } from "./MassOutages.vue?vue&type=template&id=f883bf1a&scoped=true"
import script from "./MassOutages.vue?vue&type=script&lang=js"
export * from "./MassOutages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f883bf1a",
  null
  
)

export default component.exports